import { render, staticRenderFns } from "./BuscarFuncionarioAdmin.vue?vue&type=template&id=6b3d83d6&scoped=true&"
import script from "./BuscarFuncionarioAdmin.vue?vue&type=script&lang=js&"
export * from "./BuscarFuncionarioAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3d83d6",
  null
  
)

export default component.exports